import { Routes, Route, Navigate } from "react-router-dom";
import { MetricsDashboardPage } from "@/pages/MetricsDashboardPage";
import { AuthCallbackPage } from "@/pages/AuthCallbackPage";
import { LoginPage } from "@/pages/LoginPage";
import { RequireAuth } from "@/components/auth/RequireAuth";

export function App() {
  return (
    <Routes>
      {/* Public — login form (simple mode) + Auth0 → BFF callback. No guard. */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />

      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route
        path="/home"
        element={
          <RequireAuth>
            <MetricsDashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="*"
        element={<div className="p-6 text-sm">Page not found</div>}
      />
    </Routes>
  );
}
